import {
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
	Typography,
} from '@mui/material';
import * as React from 'react';
import { Control, Controller } from 'react-hook-form';
import colors from '../../../../../../util/palette';
import { ResourceType } from '../../../api/resources';
import {
	DATE_COMPLIANCE_TYPE_DOCUMENT_TEMPLATE,
	DATE_COMPLIANCE_TYPE_FORMULA_TEMPLATE,
	DATE_COMPLIANCE_TYPE_STATIC_DOC,
	DATE_COMPLIANCE_TYPE_TABLE,
} from '../../../data/constants';
import { ResourcesFormData } from './DeployResourcesModal';

interface ResourceTypeRadioGroupProps {
	control: Control<ResourcesFormData>;
}

const options = [
	{
		id: ResourceType.TABLES,
		label: DATE_COMPLIANCE_TYPE_TABLE(),
	},
	{
		id: ResourceType.STATIC_DOCUMENTS,
		label: DATE_COMPLIANCE_TYPE_STATIC_DOC(),
	},
	{
		id: ResourceType.DOCUMENT_TEMPLATES,
		label: DATE_COMPLIANCE_TYPE_DOCUMENT_TEMPLATE(),
	},
	{
		id: ResourceType.FORMULA_TEMPLATES,
		label: DATE_COMPLIANCE_TYPE_FORMULA_TEMPLATE(),
	},
];

const ResourceTypeRadioGroup = (props: ResourceTypeRadioGroupProps) => (
	<FormControl component='fieldset'>
		<Controller
			name='resourceType'
			control={props.control}
			render={({ field }) => (
				<RadioGroup {...field} row>
					{options.map((option) => (
						<FormControlLabel
							key={option.id}
							sx={{
								fontSize: '14px',
							}}
							value={option.id}
							control={
								<Radio
									size='small'
									sx={{
										'&.Mui-checked': {
											color: colors.secondary.main,
										},
									}}
								/>
							}
							label={
								<Typography variant='body2' sx={{ fontSize: '13px' }}>
									{option.label}
								</Typography>
							}
						/>
					))}
				</RadioGroup>
			)}
		/>
	</FormControl>
);

export default ResourceTypeRadioGroup;
